import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as Styled from './IconButton.styled';

const IconButton = (props) => {
  const {
    children,
    toolTipComponent,
    variant,
    isDisabled,
    onClick,
    classes,
    className,
    toolTipProps,
    ...passThroughProps
  } = props;

  const ButtonComponent = (
    <Styled.IconButtonComponent
      role={'button'}
      variant={variant}
      onClick={onClick}
      className={classnames(className, classes.root)}
      disabled={isDisabled}
      {...passThroughProps}>
      {children}
    </Styled.IconButtonComponent>
  );

  if (toolTipComponent) {
    return (
      <Styled.TooltipComponent
        arrow
        placement="top"
        title={toolTipComponent}
        //Lower case just to bypass the console error.
        buttonvariant={variant}
        {...toolTipProps}>
        {ButtonComponent}
      </Styled.TooltipComponent>
    );
  }
  return ButtonComponent;
};

IconButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]).isRequired,
  toolTipComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  variant: PropTypes.oneOf(['primary', 'none']), // A lot of times we need a icon which is just clickable without any colour change. Use none in that case.
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
  toolTipProps: PropTypes.object, //props that needs to be passed on to tool tip component.
  'aria-label': PropTypes.string,
};

IconButton.defaultProps = {
  toolTipComponent: null,
  variant: 'primary',
  isDisabled: false,
  className: '',
  classes: {
    root: '',
  },
  'aria-label': '',
  toolTipProps: {},
};

export default IconButton;
